import React, {useEffect} from "react"
import {connect, useSelector} from "react-redux";


// components
import ListActivities from "./_listActivities";
import AddCategoryComponent from "./_addCategoryComponent";
import ListCategoryComponent from "./_listCategoryComponent";

// labels
import {ADD_STATE, REMOVE_STATE,} from "../../../../redux/actions/generics/IndexedActions";

// actions
import {setFilter, setForm, setItem, setTableParams} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {categoryUdnService} from "../../../../jwt/_services/park/DynamicModuleService";

// utils
import {getStateByPath} from "../../../../redux/selectors";





const DynamicModuleCategories = props => {
    const {mainPath} = props
    const categoriesPath = '/categoryUdn';
    const activitiesPath = '/activitiesByCategoryUdn';

    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const { domainObject:udn, app:{ fbDataBase } } = udnState?.data;




    // creación del state específico para las categorías
    useEffect(() => {
        props.ADD_STATE(categoriesPath);
        props.ADD_STATE(activitiesPath);

        return () => {
            props.REMOVE_STATE(categoriesPath);
            props.REMOVE_STATE(activitiesPath);
        }
    }, []);









    // Carga inicial de las categorías asignadas a la UDN
    useEffect(() => {
        const filter = {
            fbDataBase: { id: fbDataBase?.id },
            item: { udn: { id: udn?.id }, }
        }
        
        genericIndexedActions.search(categoriesPath, categoryUdnService, 0, 1000, filter)
    }, []);






    return <>
        <AddCategoryComponent
            mainPath={mainPath}
            categoriesPath={categoriesPath}
        />

        <br/>
        <br/>

        <ListCategoryComponent
            mainPath={mainPath}
            categoriesPath={categoriesPath}
        />

        <br/>

        <ListActivities
            mainPath={mainPath}
            categoriesPath={categoriesPath}
            activitiesPath={activitiesPath}
        />
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
    ADD_STATE,
    REMOVE_STATE,
})

export default connect(mapStateToProps, mapActionsToProps)(DynamicModuleCategories);